export function Email({ className }: { className?: string }) {
  return (
    <svg
      width="56"
      height="56"
      viewBox="0 0 56 56"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33325 11.6667C8.04459 11.6667 6.99992 12.7113 6.99992 14V42C6.99992 43.2887 8.04459 44.3333 9.33325 44.3333H46.6666C47.9552 44.3333 48.9999 43.2887 48.9999 42V14C48.9999 12.7113 47.9552 11.6667 46.6666 11.6667H9.33325ZM2.33325 14C2.33325 10.134 5.46726 7 9.33325 7H46.6666C50.5326 7 53.6666 10.134 53.6666 14V42C53.6666 45.866 50.5326 49 46.6666 49H9.33325C5.46726 49 2.33325 45.866 2.33325 42V14Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.69728 15.0819C3.38843 13.9943 4.83042 13.6728 5.91807 14.364L26.8407 27.6593C27.1885 27.8759 27.5901 27.9907 28 27.9907C28.4098 27.9907 28.8114 27.8759 29.1593 27.6593C29.161 27.6582 29.1627 27.6571 29.1645 27.656L50.0819 14.364C51.1695 13.6728 52.6115 13.9943 53.3027 15.0819C53.9938 16.1695 53.6724 17.6115 52.5847 18.3027L31.6422 31.6107C30.5505 32.2946 29.2882 32.6574 28 32.6574C26.7117 32.6574 25.4495 32.2946 24.3578 31.6106L24.3452 31.6027L3.41521 18.3027C2.32756 17.6115 2.00613 16.1695 2.69728 15.0819Z"
        fill="currentColor"
      />
    </svg>
  )
}
